/** 청구 첨부 서류 유형 (ClaimApplicationDetail · 공통 첨부 등과 공유) */
export const CLAIM_DOCUMENT_TYPE_OPTIONS = [
  { value: '', label: '미분류' },
  { value: 'ETC', label: '기타' },
  { value: 'MEDICAL_RECEIPT', label: '진료비 영수증' },
  { value: 'MEDICAL_DETAIL_STATEMENT', label: '진료비 세부산정내역서' },
  { value: 'DIAGNOSIS_CERTIFICATE', label: '진단서/소견서' },
  { value: 'HOSPITALIZATION_CONFIRMATION', label: '입퇴원확인서' },
  { value: 'SURGERY_CONFIRMATION', label: '수술확인서' },
  { value: 'PRESCRIPTION', label: '처방전/약제비' },
  { value: 'ID_CARD', label: '신분증' },
  { value: 'BANKBOOK', label: '통장사본' },
]

/** 일반 실손·입원 청구 시 자주 요구되는 유형(참고용, 의무 아님) */
export const CLAIM_RECOMMENDED_DOCUMENT_TYPES = [
  { value: 'MEDICAL_RECEIPT', label: '진료비 영수증' },
  { value: 'MEDICAL_DETAIL_STATEMENT', label: '진료비 세부산정내역서' },
  { value: 'DIAGNOSIS_CERTIFICATE', label: '진단서/소견서' },
  { value: 'ID_CARD', label: '신분증' },
  { value: 'BANKBOOK', label: '통장사본' },
]
